import {Controller} from "stimulus"
import $ from 'jquery';
import {post} from "@rails/request.js";
import bootbox from "bootbox";
import toastr from "toastr";
import {validate_email} from "./verificaciones_controller";
import {blockElementsById, unBlockElementById} from "./blockUI_controller";
import {
    add_direct_product_to_cart,
    create_array_for_product,
    create_id_for_product,
    create_shopping_cart
} from "./b2b_controller";
import {setSessionVar} from "./sessionStorage_controller";


export default class extends Controller {
    static targets = ["inputPaymentMethod", "extraFincimex", "extraCash", "currencyCash", "numRooms", "roomsContainer", "submitButton", "hotelSelect", "dateRange", "addRoomToVirtualCard", "completeBooking"]

    connect() {
        if (this.element.dataset.connect) {
            return;
        }

        this.generateRooms()
        this.validateForm()
    }

    selectPaymentMethod(event) {
        const selectedValue = event.target.value;
        console.log("Seleccionado:", selectedValue);

        if (selectedValue === "fincimex") {
            this.extraFincimexTarget.classList.remove("hide-tooltip-form");
            this.extraCashTarget.classList.add("hide-tooltip-form");
        } else if (selectedValue === "cash") {
            this.extraCashTarget.classList.remove("hide-tooltip-form");
            this.extraFincimexTarget.classList.add("hide-tooltip-form");
        } else {
            this.extraFincimexTarget.classList.add("hide-tooltip-form");
            this.extraCashTarget.classList.add("hide-tooltip-form");
            this.completeBookingTarget.classList.remove("disabled");
        }
    }

    get selectedRadioPaymentMethod() {
        const checked = this.inputPaymentMethodTargets.find(radio => radio.checked)
        return checked ? checked.value : null
    }

    validateInputPayment(event) {
        const input = event.target
        const ph = input.placeholder.toLowerCase()
        let raw = input.value

        // Correo electrónico (async)
        if (ph.includes("correo")) {
            validate_email(raw).then(success => {
                if (success) {
                    input.classList.remove("is-invalid")
                    input.classList.add("is-valid")
                } else {
                    input.classList.add("is-invalid")
                    input.classList.remove("is-valid")
                }
                this.toggleButton() // actualizar el botón después de la validación async
            })
            return // ⬅️ IMPORTANTE: salimos aquí porque la validación es async
        }

        // --- IMPORTE: solo dígitos con decimales opcionales (. o ,), máx 2 decimales ---
        if (ph.includes("importe")) {
            raw = raw.replace(/,/g, ".").slice(0, 10)
            // Permite teclear progresivamente: "","1","1.","1.2","1.23"
            // Todo lo demás lo recorta
            const match = raw.match(/^\d*(?:\.\d{0,2})?$/)
            if (!match) {
                // borra el último char inválido
                raw = raw.slice(0, -1)
            }
            input.value = raw
            this._markValidity(input, raw !== "" && /^\d+(?:\.\d{1,2})?$/.test(raw))
            return this.toggleButton()
        }

        // Moneda con select
        if (ph.includes("moneda") || input.name === "currency") {
            if (!value) {
                input.classList.add("is-invalid")
                input.classList.remove("is-valid")
            } else {
                input.classList.remove("is-invalid")
                input.classList.add("is-valid")
            }
            this.toggleButton()
            return
        }

        // --- FECHA: dd/mm/yyyy con máscara y rangos parciales ---
        if (ph.includes("fecha")) {
            let d = raw.replace(/\D/g, "").slice(0, 8) // solo dígitos, máx 8 (ddmmyyyy)

            // validación parcial por pasos (evita cosas tipo 40/99/____)
            if (d.length >= 1 && parseInt(d[0], 10) > 3) d = d.slice(0, -1)
            if (d.length >= 2) {
                const day = parseInt(d.slice(0, 2), 10)
                if (day === 0 || day > 31) d = d.slice(0, -1)
            }
            if (d.length >= 3 && parseInt(d[2], 10) > 1) d = d.slice(0, -1)
            if (d.length >= 4) {
                const month = parseInt(d.slice(2, 4), 10)
                if (month === 0 || month > 12) d = d.slice(0, -1)
            }

            // Formatear máscara
            let formatted = d
            if (d.length > 2) formatted = d.slice(0, 2) + "/" + d.slice(2)
            if (d.length > 4) formatted = d.slice(0, 2) + "/" + d.slice(2, 4) + "/" + d.slice(4)
            input.value = formatted

            // Validez final: cuando tiene 8 dígitos, confirmar fecha real (incluye feb/leap)
            let ok = false
            if (d.length === 8) {
                const day = parseInt(d.slice(0, 2), 10)
                const month = parseInt(d.slice(2, 4), 10)
                const year = parseInt(d.slice(4), 10)
                ok = this._isValidDateDMY(day, month, year)
            }
            this._markValidity(input, ok)
            return this.toggleButton()
        }

        // --- HORA: hh:mm:ss con máscara y rangos ---
        if (ph.includes("hora")) {
            let t = raw.replace(/\D/g, "").slice(0, 6) // hhmmss

            // validación parcial por pasos (evita 29:99:99)
            if (t.length >= 1 && parseInt(t[0], 10) > 2) t = t.slice(0, -1)
            if (t.length >= 2) {
                const hh = parseInt(t.slice(0, 2), 10)
                if (hh > 23) t = t.slice(0, -1)
            }
            if (t.length >= 3 && parseInt(t[2], 10) > 5) t = t.slice(0, -1)
            if (t.length >= 4) {
                const mm = parseInt(t.slice(2, 4), 10)
                if (mm > 59) t = t.slice(0, -1)
            }
            if (t.length >= 5 && parseInt(t[4], 10) > 5) t = t.slice(0, -1)
            if (t.length >= 6) {
                const ss = parseInt(t.slice(4, 6), 10)
                if (ss > 59) t = t.slice(0, -1)
            }

            // Formatear máscara
            let formatted = t
            if (t.length > 2) formatted = t.slice(0, 2) + ":" + t.slice(2)
            if (t.length > 4) formatted = t.slice(0, 2) + ":" + t.slice(2, 4) + ":" + t.slice(4)
            input.value = formatted

            const ok = t.length === 6 // ya pasó validaciones parciales
            this._markValidity(input, ok)
            return this.toggleButton()
        }

        // --- Genérico obligatorio (*): no vacío ---
        if (ph.trim().startsWith("*")) {
            const ok = input.value.trim() !== ""
            this._markValidity(input, ok)
            return this.toggleButton()
        }

        // Campos opcionales: nunca inválidos (solo limpiar clases)
        this._markValidity(input, true, true)
        this.toggleButton()
    }

    // Helpers dentro del mismo controller:
    _markValidity(input, ok, optional = false) {
        if (ok) {
            input.classList.add("is-valid")
            input.classList.remove("is-invalid")
        } else {
            // Si es opcional y vacío, no lo marques inválido
            if (optional && input.value.trim() === "") {
                input.classList.remove("is-invalid", "is-valid")
                return
            }
            input.classList.add("is-invalid")
            input.classList.remove("is-valid")
        }
    }

    _isValidDateDMY(d, m, y) {
        const date = new Date(y, m - 1, d)
        // Puedes añadir límites si quieres, p. ej. año razonable:
        if (y < 1900 || y > 2100) return false
        return date.getFullYear() === y && date.getMonth() === m - 1 && date.getDate() === d
    }

    toggleButton() {
        // Selecciona solo los campos obligatorios (con "*" en el placeholder o clase "required")
        const requiredInputs = Array.from(this.extraFincimexTarget.querySelectorAll("input")).filter(input =>
            input.placeholder.trim().startsWith("*") || input.classList.contains("required")
        )

        // Revisa si alguno está vacío o con clase is-invalid
        const hasInvalid = requiredInputs.some(input => {
            const valueEmpty = !input.value.trim()
            const invalidClass = input.classList.contains("is-invalid")
            return valueEmpty || invalidClass
        })

        if (hasInvalid) {
            this.completeBookingTarget.classList.add("disabled")
        } else {
            this.completeBookingTarget.classList.remove("disabled")
        }
    }


    // Si quieres obtener todos los valores válidos cuando lo necesites
    getExtraInputs() {
        const opcion2 = document.querySelector('input[name="opcionPaymentMethod"][value="fincimex"]')
        if (!opcion2 || !opcion2.checked) return null

        // IMPORTANT: incluir selects además de inputs
        const nodes = this.extraFincimexTarget.querySelectorAll("input, select, textarea")
        let valores = {}
        let valid = true

        for (const el of nodes) {
            const rawLabel = (el.placeholder || el.name || el.dataset.label || "").toString()
            const valueRaw = (el.value || "").toString().trim()
            const key = this._normalizeKey(rawLabel.replace("*", "").trim())

            const isRequired = (rawLabel && rawLabel.trim().startsWith("*")) ||
                el.classList.contains("required") ||
                el.required

            // required vacío
            if (isRequired && !valueRaw) {
                el.classList.add("is-invalid")
                el.classList.remove("is-valid")
                valid = false
                continue
            }

            // CORREO (async): validar y marcar
            if (key.includes("correo") && valueRaw) {
                try {
                    const ok = validate_email(valueRaw) // tu función externa
                    if (!ok) {
                        el.classList.add("is-invalid")
                        el.classList.remove("is-valid")
                        valid = false
                        continue
                    } else {
                        el.classList.remove("is-invalid")
                        el.classList.add("is-valid")
                        valores[key] = valueRaw
                        continue
                    }
                } catch (err) {
                    // si la validación externa falla por red, marcar inválido
                    el.classList.add("is-invalid")
                    el.classList.remove("is-valid")
                    valid = false
                    continue
                }
            }

            // IMPORTE: normalizar coma -> punto y validar decimales (0-2)
            if (key.includes("importe") && valueRaw) {
                const normalized = valueRaw.replace(",", ".")
                if (!/^\d+(\.\d{1,2})?$/.test(normalized)) {
                    el.classList.add("is-invalid")
                    el.classList.remove("is-valid")
                    valid = false
                    continue
                }
                el.value = normalized
                el.classList.remove("is-invalid")
                el.classList.add("is-valid")
                valores[key] = normalized
                continue
            }

            // MONEDA: puede venir como select (name 'currency') o label 'moneda'
            if (key.includes("moneda") || key.includes("currency") || (el.tagName === "SELECT" && (el.name || "").toLowerCase().includes("currency"))) {
                if (!valueRaw) {
                    el.classList.add("is-invalid")
                    el.classList.remove("is-valid")
                    valid = false
                    continue
                }
                el.classList.remove("is-invalid")
                el.classList.add("is-valid")
                valores[key] = valueRaw
                continue
            }

            // FECHA: formato y validez real
            if (key.includes("fecha") && valueRaw) {
                const match = valueRaw.match(/^(\d{2})\/(\d{2})\/(\d{4})$/)
                if (!match || !this._isValidDateDMY(+match[1], +match[2], +match[3])) {
                    el.classList.add("is-invalid")
                    el.classList.remove("is-valid")
                    valid = false
                    continue
                }
                el.classList.remove("is-invalid")
                el.classList.add("is-valid")
                valores[key] = valueRaw
                continue
            }

            // HORA: hh:mm:ss y rangos
            if (key.includes("hora") && valueRaw) {
                const match = valueRaw.match(/^(\d{2}):(\d{2}):(\d{2})$/)
                if (!match) {
                    el.classList.add("is-invalid")
                    el.classList.remove("is-valid")
                    valid = false
                    continue
                }
                const hh = parseInt(match[1], 10), mm = parseInt(match[2], 10), ss = parseInt(match[3], 10)
                if (hh > 23 || mm > 59 || ss > 59) {
                    el.classList.add("is-invalid")
                    el.classList.remove("is-valid")
                    valid = false
                    continue
                }
                el.classList.remove("is-invalid")
                el.classList.add("is-valid")
                valores[key] = valueRaw
                continue
            }

            // Por defecto: si tiene valor, lo guardo; si no, lo pongo null (si no es required)
            if (valueRaw) {
                el.classList.remove("is-invalid")
                el.classList.add("is-valid")
                valores[key] = valueRaw
            } else {
                el.classList.remove("is-invalid")
                el.classList.remove("is-valid")
                valores[key] = null
            }
        } // end for

        if (!valid) {
            console.warn("Errores en campos obligatorios o con formato inválido")
            return null
        }

        return valores
    }

    // 🔹 Helper para normalizar claves
    _normalizeKey(key) {
        return key
            .normalize("NFD")                 // separa letras y acentos
            .replace(/[\u0300-\u036f]/g, "")  // elimina acentos
            .replace(/[^a-zA-Z0-9_]/g, "_")   // reemplaza lo raro por "_"
            .replace(/_+/g, "_")              // compacta "__" → "_"
            .replace(/^_+|_+$/g, "")          // quita "_" al inicio o final
            .toLowerCase()
    }

    generateRooms() {
        const desiredCount = parseInt(this.numRoomsTarget.value || "1")
        const currentCount = this.roomsContainerTarget.querySelectorAll(".room-card").length

        if (desiredCount > currentCount) {
            for (let i = currentCount; i < desiredCount; i++) {
                this.addRoom(i)
            }
        } else if (desiredCount < currentCount) {
            const allCards = this.roomsContainerTarget.querySelectorAll(".room-card")
            for (let i = currentCount - 1; i >= desiredCount; i--) {
                allCards[i].remove()
            }
        }

        this.validateForm()
    }

    addRoom(index) {
        const wrapper = document.createElement("div")
        /*wrapper.className = "card p-3 m-3 room-card col-2"*/
        wrapper.className = "card p-3 mt-3 room-card col-12 col-sm-6 col-lg-4 col-xl-3"
        wrapper.innerHTML = `
            <h5>Habitación ${index + 1}</h5>
            <div class="mb-2">
              <label for="rooms_${index}_num_guests">Personas:</label>
              <input type="number"
                     id="rooms_${index}_num_guests"
                     name="rooms[${index}][num_guests]"
                     min="1"
                     max="10"
                     value="1"
                     class="form-control mb-2 guest-count"
                     data-action="input->hotetec#updateGuestAges"
                     data-room-index="${index}">
            </div>
            <div class="ages-container" id="ages-room-${index}"></div>
          `
        this.roomsContainerTarget.appendChild(wrapper)

        this.buildAgeInputs(index, 1)
        this.validateForm()
    }

    updateGuestAges(event) {
        const roomIndex = event.target.dataset.roomIndex
        const newCount = parseInt(event.target.value || "0")
        const container = document.getElementById(`ages-room-${roomIndex}`)

        const oldValues = Array.from(container.querySelectorAll("input")).map(input => input.value)

        container.innerHTML = ""

        for (let i = 0; i < newCount; i++) {
            const input = document.createElement("input")
            input.type = "number"
            input.name = `rooms[${roomIndex}][guests][]`
            input.placeholder = `Edad persona ${i + 1}`
            input.min = 0
            input.className = "form-control mb-2"
            input.value = oldValues[i] || ""

            input.addEventListener("keypress", this.blockNonNumeric)
            input.addEventListener("input", () => this.validateForm())

            container.appendChild(input)
        }

        this.validateForm()
    }

    buildAgeInputs(roomIndex, count) {
        const container = document.getElementById(`ages-room-${roomIndex}`)
        container.innerHTML = ""

        for (let i = 0; i < count; i++) {
            const input = document.createElement("input")
            input.type = "number"
            input.name = `rooms[${roomIndex}][guests][]`
            input.placeholder = `Edad persona ${i + 1}`
            input.min = 0
            input.className = "form-control mb-2"

            input.addEventListener("keypress", this.blockNonNumeric)
            input.addEventListener("input", () => this.validateForm())

            container.appendChild(input)
        }
    }

    blockNonNumeric(event) {
        const charCode = event.charCode
        if (charCode < 48 || charCode > 57) {
            event.preventDefault()
        }
    }

    validateForm() {
        const hotelSelected = this.hasHotelSelectTarget && this.hotelSelectTarget.value.trim() !== ""
        const dateSelected = this.hasDateRangeTarget && this.dateRangeTarget.value.trim() !== ""

        const ageInputs = this.roomsContainerTarget.querySelectorAll("input[name*='guests']")
        let allValid = hotelSelected && dateSelected

        ageInputs.forEach(input => {
            const value = input.value.trim()
            const isValid = value !== "" && !isNaN(value) && Number(value) >= 0 && Number(value) < 150

            if (!isValid) {
                input.classList.add("is-invalid")
                input.classList.remove("is-valid")
                allValid = false
            } else {
                input.classList.remove("is-invalid")
                input.classList.add("is-valid")
            }
        })

        if (this.hasSubmitButtonTarget) {
            this.submitButtonTarget.disabled = !allValid
        }
    }

    /* Agregar Habitación al Carrito virtual */
    book_room(e) {
        let rate_code = e.target.dataset.rate_code;
        let room_code = e.target.dataset.room_code;
        let meal_plan_code = e.target.dataset.meal_plan_code;
        let occupancy_code = e.target.dataset.occupancy_code;
        let target = e.target.dataset.target;
        let target_message = e.target.dataset.message;
        let customerFrontendRoom = document.getElementById("customerFrontendRoom")
        let url_default = '/admin/hotel/add_room_to_virtual_card'

        $(`#${target}`).html(`<div style="height: 250px"></div>`);

        /* El beforeSend se maneja manualmente */
        const beforeSend = () => {
            console.log('Antes del envío');
            $(`#div-my-virtual-card`).addClass(`mb-3`);
            $(`#my-virtual-card`).addClass(`card card-body`);
            // blockElementsById(target, `<div class="d-flex flex-column justify-content-center align-items-center"><span class="fa fa-spinner fa-spin"></span> <span>${I18n.t('global.main.form.message.create_shooping_cart')}</span></div> `, 'rgba(0,0,0,0)', '#ffffff', 'rgba(0,0,0,.6)');
            // blockElementsById(target, `<div class="d-flex flex-column justify-content-center align-items-center"><span class="fa fa-spinner fa-spin"></span> <span>Cargandoooooooooo...</span></div> `, 'rgba(0,0,0,0)', '#ffffff', 'rgba(0,0,0,.6)');
            blockElementsById(target, `<div class="d-flex flex-column justify-content-center align-items-center"><span class="fa fa-4x fa-spinner fa-spin"></span> <h4 class="w-100 text-center text-info">
                    <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" fill="currentColor" class="mr-2" viewBox="0 0 16 16" aria-hidden="true">
                        <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm0-1.5A6.5 6.5 0 1 1 8 1.5a6.5 6.5 0 0 1 0 13zm.93-6.588c-.07-.07-.162-.112-.26-.112h-1.34c-.098 0-.19.042-.26.112a.37.37 0 0 0-.11.26c0 .098.042.19.11.26.07.07.162.112.26.112h.47v2.5a.37.37 0 0 0 .37.37h.26a.37.37 0 0 0 .37-.37v-2.5h.47c.098 0 .19-.042.26-.112a.37.37 0 0 0 .11-.26.37.37 0 0 0-.11-.26zm-.93-2.412a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5z"/>
                    </svg>
                    ${target_message}
                    </h4></div> `, 'rgba(0,0,0,0)', '#ffffff', 'rgba(0,0,0,.2)');
        };




        beforeSend();

        if(customerFrontendRoom){
            url_default = '/add_room_to_virtual_card'
        }

        console.log("METODO DE AGREGAR ROOM")
        console.log(url_default)

        post(`${url_default}`, {
            query: {
                rate_code: rate_code,
                room_code: room_code,
                meal_plan_code: meal_plan_code,
                occupancy_code: occupancy_code,
                target: target
            },
            responseKind: "turbo-stream"
        }).then(r => {
            /*this.isLogin(r);
            this.setDealerData()*/
            console.log("Room added to virtual card successfully");
        });
    }

    remove_book_room(e) {
        let bookedroomid = e.target.dataset.bookedroomid;
        let target = e.target.dataset.target;
        let target_message = e.target.dataset.message;
        let customerFrontendRoom = document.getElementById("customerFrontendRoom");
        let url_default = '/admin/hotel/remove_room_to_virtual_card';

        bootbox.confirm({
            title: "Remover habitación",
            message: "¿Seguro que desea remover la habitación?",
            buttons: {
                confirm: {
                    label: '<i class="fa fa-check"></i> Aceptar',
                    className: 'btn-success'
                },
                cancel: {
                    label: '<i class="fa fa-times"></i> Cancelar',
                    className: 'btn-secondary'
                }
            },
            size: 'medium',
            callback: function (result) {
                if (result) {
                    $(`#${target}`).html(`<div style="height: 250px"></div>`);

                    /* El beforeSend se maneja manualmente */
                    const beforeSend = () => {
                        console.log('Antes del envío');
                        // blockElementsById(target, `<div class="d-flex flex-column justify-content-center align-items-center"><span class="fa fa-spinner fa-spin"></span> <span>${I18n.t('global.main.form.message.create_shooping_cart')}</span></div> `, 'rgba(0,0,0,0)', '#ffffff', 'rgba(0,0,0,.6)');
                        // blockElementsById(target, `<div class="d-flex flex-column justify-content-center align-items-center"><span class="fa fa-spinner fa-spin"></span> <span>Cargandoooooooooo...</span></div> `, 'rgba(0,0,0,0)', '#ffffff', 'rgba(0,0,0,.6)');
                        blockElementsById(target, `<div class="d-flex flex-column justify-content-center align-items-center"><span class="fa fa-4x fa-spinner fa-spin"></span> <h4 class="w-100 text-center text-info">
                                <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" fill="currentColor" class="mr-2" viewBox="0 0 16 16" aria-hidden="true">
                                    <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm0-1.5A6.5 6.5 0 1 1 8 1.5a6.5 6.5 0 0 1 0 13zm.93-6.588c-.07-.07-.162-.112-.26-.112h-1.34c-.098 0-.19.042-.26.112a.37.37 0 0 0-.11.26c0 .098.042.19.11.26.07.07.162.112.26.112h.47v2.5a.37.37 0 0 0 .37.37h.26a.37.37 0 0 0 .37-.37v-2.5h.47c.098 0 .19-.042.26-.112a.37.37 0 0 0 .11-.26.37.37 0 0 0-.11-.26zm-.93-2.412a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5z"/>
                                </svg>
                                ${target_message}
                                </h4></div> `, 'rgba(0,0,0,0)', '#ffffff', 'rgba(0,0,0,.2)');
                    };

                    beforeSend();

                    if(customerFrontendRoom){
                        url_default = '/remove_room_to_virtual_card'
                    }

                    console.log("METODO DE REMOVER ROOM")
                    console.log(customerFrontendRoom)
                    console.log(url_default)

                    post(`${url_default}`, {
                        query: {
                            bookedroomid: bookedroomid,
                            target: target
                        },
                        responseKind: "turbo-stream"
                    }).then(r => {
                        /*this.isLogin(r);
                        this.setDealerData()*/
                        console.log("Habitación Removida");
                    });
                }
            }
        })
    }


    ////////////////////////////////////////////////////////////////////////////////////////////////////////////

    sessionVarsForShoppingCart() {

        let sell_type = '';
        if (document.getElementById('sell_type') !== null && document.getElementById('sell_type') !== undefined) {
            sell_type = document.getElementById('sell_type').getAttribute('data-type');
        } else {
            sell_type = 'b2b';
        }

        let booking = false;
        if (sell_type === 'b2c') {
            booking = true;
        }

        sessionStorage.setItem('add_product_url', '');
        sessionStorage.setItem('modify_product_url', '');
        sessionStorage.setItem('comment_shopping', `Creado desde la Web de Ventas Online ${location.origin}/${sessionStorage.getItem('locale')}`);
        sessionStorage.setItem('immediate_payment', 'yes');
        sessionStorage.setItem('one_item', 'no');
        sessionStorage.setItem('customer_notify', 'yes');
        sessionStorage.setItem('locale', sessionStorage.getItem('locale'));
        sessionStorage.setItem('only_booking', booking);
        sessionStorage.setItem('success_url', location.origin + `/${sessionStorage.getItem('locale')}/payment/success`);
        sessionStorage.setItem('return_url', location.origin + `/${sessionStorage.getItem('locale')}/payment/return`);
        sessionStorage.setItem('error_url', location.origin + `/${sessionStorage.getItem('locale')}/payment/error`);
        sessionStorage.setItem('cancel_url', location.origin + `/${sessionStorage.getItem('locale')}/payment/cancel`);
    }
    /////////////////////////////////////////////////////////////////////////////////////////////////////////////
    getStructuredDate(time) {
        const date = new Date(time);

        const day = String(date.getDate() + 1).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();

        return `${day}/${month}/${year}`;
    }

    ////

    create_car(e){
        let product_array = {}
        // this.sessionVarsForShoppingCart()

        let locale = sessionStorage.getItem('locale')
        let enable_analytics = sessionStorage.getItem('enable_analytics')
        let cart_count_product = sessionStorage.getItem('cart_count_product')
        let seller = sessionStorage.getItem('seller')

        // if (create_array_for_product('product_type', '', 'show') === undefined) {
        //     let product_type = 'hotel_hotetec';
        //     create_array_for_product('product_type', product_type);
        // }
        //
        // if (create_array_for_product('id', '', 'show') === undefined) {
        //     create_id_for_product(create_array_for_product('category_id', '', 'show'), create_array_for_product('dealer_code', '', 'show'), create_array_for_product('category_code', '', 'show'), create_array_for_product('modality_code', '', 'show'), create_array_for_product('pax', '', 'show')).then()
        // }

        let form = $('#hotel-container-card');
        let block_target = 'hotel-container-card';


        let set_reservation_cart_time = async () => {
            let date = new Date();
            let save_date = date.setMinutes(date.getMinutes() + 8);
            let reservation = await setSessionVar('reservation_time', save_date, 'add', false);
            return !!reservation.success;
        }

        let userName = document.getElementById('user-name').textContent;
        let userLastName = document.getElementById('user-lastname').textContent;
        let userEmail = document.getElementById('user-email').textContent;
        let userPhone = document.getElementById('user-phone').textContent;


        let hotel_code = document.getElementById('shopc-hotel-code').textContent;
        let hotel_name = document.getElementById('shopc-hotel-name').textContent;
        let hotel_address = document.getElementById('shopc-hotel-address').textContent;
        let hotel_price = document.getElementById('shopc-hotel-price').textContent;
        let hotel_rooms = document.getElementById('shopc-hotel-rooms').textContent;
        let checkIn = document.getElementById('shopc-hotel-checkIn').textContent;
        let checkOut = document.getElementById('shopc-hotel-checkOut').textContent;
        let nights = document.getElementById('shopc-hotel-nights').textContent;
        let hotel_description = document.getElementById('shopc-hotel-description').textContent;
        let hotel_id_code = document.getElementById('shopc-hotel-id-code').textContent;
        let hotel_dealer_code = document.getElementById('shopc-hotel-dealer-code').textContent;
        let hotel_dealer_name = document.getElementById('shopc-hotel-dealer-name').textContent;

        checkIn = Number(checkIn);
        checkOut = Number(checkOut);

        let checkInDate = this.getStructuredDate(checkIn)
        let checkOutDate = this.getStructuredDate(checkOut)

        const paymentMethod = this.selectedRadioPaymentMethod;
        const extraInputsFincimex = this.getExtraInputs();
        let currency_cash = this.currencyCashTarget.value;
        let guestCount = e.target.dataset.guest;
        let url_go = e.target.dataset.urlgo;
        let customerFrontendRoom = document.getElementById("customerFrontendRoom");
        let url_default = '/admin/hotel/complete_booking';

        if (customerFrontendRoom) {
            currency_cash = document.getElementById('currency_cash').value;
        }

        if (this.completeBookingTarget.classList.contains("disabled")) {
            event.preventDefault()
            event.stopPropagation()
            console.warn("No puedes completar la reserva: faltan campos.")
            toastr.error("No puedes completar la reserva: faltan campos.");
            return
        }

        let target = e.target.dataset.target;
        let target_message = e.target.dataset.message;
        let context = this;

        let guestsFields = "";
        // for (let i = 0; i < guestCount.split(',').length; i++) {
        $.each(guestCount.split(','), function (i, value) {
            guestsFields += `
                ${(i === 0) ? '<hr class="mt-3"><h6>Nombre y Apellidos de los Huéspedes</h6>' : ''}
                <div class="row mb-3" style="gap: .5em 0;">
                    <div class="col-md-6">
                        <input type="text" id="guest_${value}_first_name" name="guests[${value}][first_name]" placeholder="Nombre huésped ${i + 1}" class="form-control required">
                    </div>
                    <div class="col-md-6">
                        <input type="text" id="guest_${value}_last_name" name="guests[${value}][last_name]" placeholder="Apellido huésped ${i + 1}" class="form-control required">
                    </div>
                </div>`;
        });

        unBlockElementById(block_target);

        let dialog_hotel_contact_data = bootbox.dialog({
            title: 'Datos de contacto del cliente',
            message: `<div style="overflow: hidden auto; max-height: 350px; text-align: justify; padding: 5px 10px;"><p class='text-danger small'>(*) Campos obligatorios</p><br>
                    <div id="hotel_contact_user_form" class="row" data-controller="country">
                        <div class="col-12 mb-2">
                         <input id="hotel_contact_user_username" value="${userName}" type="text" placeholder="* Nombre de cliente" class="form-control required">
                        </div>
                        <div class="col-12 mb-2">
                         <input id="hotel_contact_user_lastname" value="${userLastName}" type="text" placeholder="* Apellidos de cliente" class="form-control required">
                        </div>
                        <div class="col-12 mb-2">
                         <input id="hotel_contact_user_email" value="${userEmail}" type="email" placeholder="* Correo Electrónico" class="form-control required">
                        </div>
                        <div class="col-12 mb-2">
                         <input id="hotel_contact_user_phone_number" value="${userPhone}" type="text" placeholder="Número de Teléfono" class="form-control">
                        </div>
                        <div class="col-12 mb-2">
                         <select id="hotel_contact_user_country_code" class="form-control"> </select>
                         <small class="text-danger"> Norma ISO de dos caracteres.</small>
                        </div>
                        <div class="col-12 mb-2">
                         <input id="hotel_contact_user_postal_code" type="text" placeholder="Código Postal" class="form-control">
                        </div>
                    </div>
                    ${guestsFields}
                              </div>`,
            size: 'md',
            buttons: {
                cancel: {
                    label: "Cancelar",
                    className: 'btn-secondary'
                },
                ok: {
                    label: "Confirmar datos",
                    className: 'btn-success',
                    callback: function (e) {
                        let count = 0;
                        let form_required = $('#hotel_contact_user_form').find('.required');
                        form_required.map((index, element) => {
                            if (element.value.isEmpty()) {
                                count += 1;
                                $(element)[0].classList.remove('is-valid');
                                $(element)[0].classList.add('is-invalid');
                            } else {
                                $(element)[0].classList.add('is-valid');
                                $(element)[0].classList.remove('is-invalid');
                            }
                        });

                        validate_email(document.getElementById('hotel_contact_user_email').value).then(
                            success => {
                                if (success) {
                                    if (count > 0) {
                                        return false;
                                    } else {
                                        toastr.info('Validando datos del cliente');
                                        // $('button.bootbox-close-button').trigger('click');

                                        /* El beforeSend se maneja manualmente */
                                        const beforeSend = () => {
                                            console.log('Antes del envío');
                                            // blockElementsById(target, `<div class="d-flex flex-column justify-content-center align-items-center"><span class="fa fa-spinner fa-spin"></span> <span>${I18n.t('global.main.form.message.create_shooping_cart')}</span></div> `, 'rgba(0,0,0,0)', '#ffffff', 'rgba(0,0,0,.6)');
                                            // blockElementsById(target, `<div class="d-flex flex-column justify-content-center align-items-center"><span class="fa fa-spinner fa-spin"></span> <span>Cargandoooooooooo...</span></div> `, 'rgba(0,0,0,0)', '#ffffff', 'rgba(0,0,0,.6)');
                                            blockElementsById(target, `<div class="d-flex flex-column justify-content-center align-items-center"><span class="fa fa-4x fa-spinner fa-spin"></span> <h4 class="w-100 text-center text-info">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" fill="currentColor" class="mr-2" viewBox="0 0 16 16" aria-hidden="true">
                                                            <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm0-1.5A6.5 6.5 0 1 1 8 1.5a6.5 6.5 0 0 1 0 13zm.93-6.588c-.07-.07-.162-.112-.26-.112h-1.34c-.098 0-.19.042-.26.112a.37.37 0 0 0-.11.26c0 .098.042.19.11.26.07.07.162.112.26.112h.47v2.5a.37.37 0 0 0 .37.37h.26a.37.37 0 0 0 .37-.37v-2.5h.47c.098 0 .19-.042.26-.112a.37.37 0 0 0 .11-.26.37.37 0 0 0-.11-.26zm-.93-2.412a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5z"/>
                                                        </svg>
                                                        ${target_message}
                                                        </h4></div> `, 'rgba(0,0,0,0)', '#ffffff', 'rgba(0,0,0,.2)');
                                        };

                                        /* Validar los nombres y apellidos de los huéspedes */
                                        let guestData = [];
                                        let validGuests = true;

                                        // for (let i = 0; i < guestCount; i++) {
                                        $.each(guestCount.split(','), function (i, value) {
                                            let firstName = document.getElementById(`guest_${value}_first_name`).value.trim();
                                            let lastName = document.getElementById(`guest_${value}_last_name`).value.trim();
                                            // Solo letras y espacios, sin números ni caracteres raros
                                            let nameRegex = /^[A-Za-zÁÉÍÓÚáéíóúÑñ\s]+$/;

                                            if (!firstName.match(nameRegex) || !lastName.match(nameRegex) || firstName === "" || lastName === "") {
                                                validGuests = false;
                                                document.getElementById(`guest_${value}_first_name`).classList.add('is-invalid');
                                                document.getElementById(`guest_${value}_last_name`).classList.add('is-invalid');
                                            } else {
                                                document.getElementById(`guest_${value}_first_name`).classList.remove('is-invalid');
                                                document.getElementById(`guest_${value}_last_name`).classList.remove('is-invalid');
                                                guestData.push({
                                                    id: value,
                                                    firstName: firstName,
                                                    lastName: lastName
                                                });
                                            }
                                        });

                                        if (!validGuests) {
                                            toastr.error("Por favor, ingrese nombres y apellidos válidos para todos los huéspedes.");
                                            return false;
                                        } else {
                                            $(`#${target}`).html(`<div style="height: 250px"></div>`);
                                            $('button.bootbox-close-button').trigger('click');
                                        }
                                        /* Validar los nombres y apellidos de los huéspedes FINN */

                                        beforeSend();
                                        if (customerFrontendRoom) {
                                            url_default = '/complete_booking'
                                        }

                                        console.log("PARAMS MODIFICADOS");
                                        console.log(url_default);
                                        console.log(currency_cash);

                                        post(`${url_default}`, {
                                            query: {
                                                username: document.getElementById('hotel_contact_user_username').value,
                                                lastname: document.getElementById('hotel_contact_user_lastname').value,
                                                email: document.getElementById('hotel_contact_user_email').value,
                                                phone_number: document.getElementById('hotel_contact_user_phone_number').value,
                                                country_code: document.getElementById('hotel_contact_user_country_code').value.toLowerCase(),
                                                postal_code: document.getElementById('hotel_contact_user_postal_code').value,
                                                payment_method: paymentMethod,
                                                currency_cash: currency_cash,
                                                url_go: url_go,
                                                ...(extraInputsFincimex || {}), /* ✅ si es null, inyecta objeto vacío y no rompe */
                                                guests: JSON.stringify(guestData)
                                            },
                                            responseKind: "json"
                                        }).then(async r => {
                                            console.log("█ █ █ █ █ █ █ █ █ █ █ █ █ █ █ █ █ █ █ █ █ █ █ █ █ █ █ █ █ ");
                                            const body = await r.json;
                                            console.log(body);
                                            console.log(body.data);
                                            console.log("█ █ █ █ █ █ █ █ █ █ █ █ █ █ █ █ █ █ █ █ █ █ █ █ █ █ █ █ █ ");
                                            if (r.ok) {
                                                // $('#div_filter_search_hotel').addClass('hide-tooltip');
                                            }
                                            if (sessionStorage.hasOwnProperty('shopping_cart_code') && (sessionStorage.hasOwnProperty('has_reservation') && sessionStorage.getItem('has_reservation') === 'true')) {
                                                blockElementsById(block_target, `<div class="d-flex flex-column justify-content-center align-items-center"><span class="fa fa-spinner fa-spin"></span> <span>${I18n.t('global.main.form.message.create_shooping_cart')}</span></div> `, 'rgba(0,0,0,0)', '#ffffff', 'rgba(0,0,0,.6)');

                                                if (create_array_for_product('product_type', '', 'show') === undefined) {
                                                    // let product_type = $('#search_form_type').val();
                                                    // let product_type = document.getElementById('search_form_type').textContent
                                                    let product_type = "hotel_hotetec";
                                                    create_array_for_product('product_type', product_type);
                                                }

                                                if (create_array_for_product('id', '', 'show') === undefined) {
                                                    create_id_for_product(create_array_for_product('category_id', '', 'show'), create_array_for_product('dealer_code', '', 'show'), create_array_for_product('category_code', '', 'show'), create_array_for_product('modality_code', '', 'show'), create_array_for_product('pax', '', 'show')).then()
                                                }

                                                console.log("ESTE ES EL IF");

                                                const match = hotel_price.match(/^(\d+(?:\.\d+)?)\s*([A-Z]{3})$/);

                                                create_array_for_product('price_hotel', parseFloat(match[1]) * 100); // PRECIO HOTEL EN CARRITO
                                                create_array_for_product('amount', hotel_rooms); //CANTIDAD DE HABITACIONES
                                                create_array_for_product('name', hotel_name); // NOMBRE DE HOTEL EN DIV
                                                create_array_for_product('text_category', hotel_name); // NOMBRE HOTEL EN CARRITO
                                                create_array_for_product('dealer', hotel_dealer_code);
                                                create_array_for_product('dealer_name', hotel_dealer_name);
                                                create_array_for_product('text_destination', hotel_address);
                                                create_array_for_product('date_collect', checkInDate); //FECHA INICIO RESERVA
                                                create_array_for_product('date_delivery', checkOutDate);// FECHA FIN RESERVA
                                                create_array_for_product('hotel_hotetec', 'hotel_hotetec');
                                                create_array_for_product('currency', match[2]);
                                                create_array_for_product('hotel_decription', hotel_description);
                                                create_array_for_product('category', hotel_id_code);

                                                console.log("PARAMS NECESARIOS");
                                                console.log("PARAMS NECESARIOS hotel_dealer_code:", hotel_dealer_code);
                                                console.log("PARAMS NECESARIOS create_array_for_product_dealer:", create_array_for_product('dealer', '', 'show'));
                                                console.log("PARAMS NECESARIOS create_array_for_product_category:", create_array_for_product('category', '', 'show'));
                                                console.log("PARAMS NECESARIOS create_array_for_product_type:", create_array_for_product('product_type', '', 'show'));


                                                add_direct_product_to_cart(form, block_target, create_array_for_product('dealer', '', 'show'), create_array_for_product('category', '', 'show'), create_array_for_product('pax', '', 'show'), create_array_for_product('product_type', '', 'show'), create_array_for_product('modality_code', '', 'show')).then(
                                                    product_add => {
                                                        if (product_add.next) {
                                                            unBlockElementById(block_target);
                                                            setTimeout(() => {
                                                                location.href = `${location.origin}/${sessionStorage.getItem('locale')}/shopping-cart`
                                                            }, 500)
                                                        } else {
                                                            unBlockElementById(block_target);
                                                            toastr.error('No se pudo añadir el producto', 'Carrito de compra')
                                                        }
                                                    }
                                                )

                                            } else {
                                                console.log("ESTE ES EL ELSE");

                                                if (create_array_for_product('product_type', '', 'show') === undefined) {
                                                    let product_type = "hotel_hotetec";
                                                    create_array_for_product('product_type', product_type);
                                                }

                                                if (create_array_for_product('id', '', 'show') === undefined) {
                                                    create_id_for_product(create_array_for_product('category_id', '', 'show'), create_array_for_product('dealer_code', '', 'show'), create_array_for_product('category_code', '', 'show'), create_array_for_product('modality_code', '', 'show'), create_array_for_product('pax', '', 'show')).then()
                                                }

                                                sessionStorage.setItem('other_param', 'hotel_hotetec');

                                                create_shopping_cart(form, block_target, create_array_for_product('product_type', '', 'show')).then(shopc => {
                                                    if (shopc.next) {
                                                        const match = hotel_price.match(/^(\d+(?:\.\d+)?)\s*([A-Z]{3})$/);

                                                        create_array_for_product('price_hotel', parseFloat(match[1]) * 100); // PRECIO HOTEL EN CARRITO
                                                        create_array_for_product('amount', hotel_rooms); //CANTIDAD DE HABITACIONES
                                                        create_array_for_product('name', hotel_name); // NOMBRE DE HOTEL EN DIV
                                                        create_array_for_product('text_category', hotel_name); // NOMBRE HOTEL EN CARRITO
                                                        create_array_for_product('dealer', hotel_dealer_code);
                                                        create_array_for_product('dealer_name', hotel_dealer_name);
                                                        create_array_for_product('text_destination', hotel_address);
                                                        create_array_for_product('date_collect', checkInDate); //FECHA INICIO RESERVA
                                                        create_array_for_product('date_delivery', checkOutDate);// FECHA FIN RESERVA
                                                        create_array_for_product('hotel_hotetec', 'hotel_hotetec');
                                                        create_array_for_product('currency', match[2]);
                                                        create_array_for_product('hotel_decription', hotel_description);
                                                        create_array_for_product('category', hotel_id_code);

                                                        console.log("PARAMS NECESARIOS");
                                                        console.log("PARAMS NECESARIOS hotel_dealer_code:", hotel_dealer_code);
                                                        console.log("PARAMS NECESARIOS create_array_for_product_dealer:", create_array_for_product('dealer', '', 'show'));
                                                        console.log("PARAMS NECESARIOS create_array_for_product_category:", create_array_for_product('category', '', 'show'));
                                                        console.log("PARAMS NECESARIOS create_array_for_product_type:", create_array_for_product('product_type', '', 'show'));


                                                        add_direct_product_to_cart(form, block_target, create_array_for_product('dealer', '', 'show'), create_array_for_product('category', '', 'show'), create_array_for_product('pax', '', 'show'), create_array_for_product('product_type', '', 'show'), create_array_for_product('modality_code', '', 'show')).then(
                                                            product_add => {
                                                                if (product_add.next) {
                                                                    unBlockElementById(block_target);
                                                                    setTimeout(() => {
                                                                        location.href = `${location.origin}/${sessionStorage.getItem('locale')}/shopping-cart`
                                                                    }, 500)
                                                                } else {
                                                                    unBlockElementById(block_target);
                                                                    toastr.error('No se pudo añadir el producto', 'Carrito de compra')
                                                                }
                                                            }
                                                        )
                                                    }
                                                })

                                            }


                                        });
                                    }
                                } else {
                                    let email_user_form = document.getElementById('hotel_contact_user_email');
                                    email_user_form.classList.add('is-invalid');
                                    email_user_form.classList.remove('is-valid');
                                    return false;
                                }
                            })
                        return false;
                    }
                }
            },
            onShown: function (e) {
                // $(this) referencia al modal generado
                $(this).attr('id', 'dialog_hotel_contact_data');

                // O más específico - el modal principal
                $('.bootbox.modal').last().attr('id', 'dialog_hotel_contact_data');

            }
        })


        // create_shopping_cart(form, block_target, create_array_for_product('product_type', '', 'show')).then(shopc => {
        //     if (shopc.next) {
        //
        //         if (this.completeBookingTarget.classList.contains("disabled")) {
        //             event.preventDefault()
        //             event.stopPropagation()
        //             console.warn("No puedes completar la reserva: faltan campos.")
        //             toastr.error("No puedes completar la reserva: faltan campos.");
        //             return
        //         }
        //
        //         let target = e.target.dataset.target;
        //         let target_message = e.target.dataset.message;
        //         let context = this;
        //
        //         let guestsFields = "";
        //         // for (let i = 0; i < guestCount.split(',').length; i++) {
        //         $.each(guestCount.split(','), function (i, value) {
        //             guestsFields += `
        //         ${(i === 0) ? '<hr class="mt-3"><h6>Nombre y Apellidos de los Huéspedes</h6>' : ''}
        //         <div class="row mb-3" style="gap: .5em 0;">
        //             <div class="col-md-6">
        //                 <input type="text" id="guest_${value}_first_name" name="guests[${value}][first_name]" placeholder="Nombre huésped ${i + 1}" class="form-control required">
        //             </div>
        //             <div class="col-md-6">
        //                 <input type="text" id="guest_${value}_last_name" name="guests[${value}][last_name]" placeholder="Apellido huésped ${i + 1}" class="form-control required">
        //             </div>
        //         </div>`;
        //         });
        //
        //         unBlockElementById(block_target);
        //         let dialog_hotel_contact_data = bootbox.dialog({
        //             title: 'Datos de contacto del cliente',
        //             message: `<div style="overflow: hidden auto; max-height: 350px; text-align: justify; padding: 5px 10px;"><p class='text-danger small'>(*) Campos obligatorios</p><br>
        //             <div id="hotel_contact_user_form" class="row" data-controller="country">
        //                 <div class="col-12 mb-2">
        //                  <input id="hotel_contact_user_username" ${(paymentMethod === 'fincimex') ? `value='${extraInputsFincimex['nombre']}'` : ''} type="text" placeholder="* Nombre de cliente" class="form-control required">
        //                 </div>
        //                 <div class="col-12 mb-2">
        //                  <input id="hotel_contact_user_lastname" ${(paymentMethod === 'fincimex') ? `value='${extraInputsFincimex['apellidos']}'` : ''} type="text" placeholder="* Apellidos de cliente" class="form-control required">
        //                 </div>
        //                 <div class="col-12 mb-2">
        //                  <input id="hotel_contact_user_email" ${(paymentMethod === 'fincimex') ? `value='${extraInputsFincimex['correo_electronico']}'` : ''} type="email" placeholder="* Correo Electrónico" class="form-control required">
        //                 </div>
        //                 <div class="col-12 mb-2">
        //                  <input id="hotel_contact_user_phone_number" type="text" placeholder="Número de Teléfono" class="form-control">
        //                 </div>
        //                 <div class="col-12 mb-2">
        //                  <select id="hotel_contact_user_country_code" class="form-control"> </select>
        //                  <small class="text-danger"> Norma ISO de dos caracteres.</small>
        //                 </div>
        //                 <div class="col-12 mb-2">
        //                  <input id="hotel_contact_user_postal_code" type="text" placeholder="Código Postal" class="form-control">
        //                 </div>
        //             </div>
        //             ${guestsFields}
        //                       </div>`,
        //             size: 'md',
        //             buttons: {
        //                 cancel: {
        //                     label: "Cancelar",
        //                     className: 'btn-secondary'
        //                 },
        //                 ok: {
        //                     label: "Confirmar datos",
        //                     className: 'btn-success',
        //                     callback: function (e) {
        //                         let count = 0;
        //                         let form_required = $('#hotel_contact_user_form').find('.required');
        //                         form_required.map((index, element) => {
        //                             if (element.value.isEmpty()) {
        //                                 count += 1;
        //                                 $(element)[0].classList.remove('is-valid');
        //                                 $(element)[0].classList.add('is-invalid');
        //                             } else {
        //                                 $(element)[0].classList.add('is-valid');
        //                                 $(element)[0].classList.remove('is-invalid');
        //                             }
        //                         });
        //
        //                         validate_email(document.getElementById('hotel_contact_user_email').value).then(
        //                             success => {
        //                                 if (success) {
        //                                     if (count > 0) {
        //                                         return false;
        //                                     } else {
        //                                         toastr.info('Validando datos del cliente');
        //                                         $('button.bootbox-close-button').trigger('click');
        //
        //                                         $(`#${target}`).html(`<div style="height: 250px"></div>`);
        //
        //                                         /* El beforeSend se maneja manualmente */
        //                                         const beforeSend = () => {
        //                                             console.log('Antes del envío');
        //                                             // blockElementsById(target, `<div class="d-flex flex-column justify-content-center align-items-center"><span class="fa fa-spinner fa-spin"></span> <span>${I18n.t('global.main.form.message.create_shooping_cart')}</span></div> `, 'rgba(0,0,0,0)', '#ffffff', 'rgba(0,0,0,.6)');
        //                                             // blockElementsById(target, `<div class="d-flex flex-column justify-content-center align-items-center"><span class="fa fa-spinner fa-spin"></span> <span>Cargandoooooooooo...</span></div> `, 'rgba(0,0,0,0)', '#ffffff', 'rgba(0,0,0,.6)');
        //                                             blockElementsById(target, `<div class="d-flex flex-column justify-content-center align-items-center"><span class="fa fa-4x fa-spinner fa-spin"></span> <h4 class="w-100 text-center text-info">
        //                                                 <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" fill="currentColor" class="mr-2" viewBox="0 0 16 16" aria-hidden="true">
        //                                                     <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm0-1.5A6.5 6.5 0 1 1 8 1.5a6.5 6.5 0 0 1 0 13zm.93-6.588c-.07-.07-.162-.112-.26-.112h-1.34c-.098 0-.19.042-.26.112a.37.37 0 0 0-.11.26c0 .098.042.19.11.26.07.07.162.112.26.112h.47v2.5a.37.37 0 0 0 .37.37h.26a.37.37 0 0 0 .37-.37v-2.5h.47c.098 0 .19-.042.26-.112a.37.37 0 0 0 .11-.26.37.37 0 0 0-.11-.26zm-.93-2.412a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5z"/>
        //                                                 </svg>
        //                                                 ${target_message}
        //                                                 </h4></div> `, 'rgba(0,0,0,0)', '#ffffff', 'rgba(0,0,0,.2)');
        //                                         };
        //
        //                                         /* Validar los nombres y apellidos de los huéspedes */
        //                                         let guestData = [];
        //                                         let validGuests = true;
        //
        //                                         // for (let i = 0; i < guestCount; i++) {
        //                                         $.each(guestCount.split(','), function (i, value) {
        //                                             let firstName = document.getElementById(`guest_${value}_first_name`).value.trim();
        //                                             let lastName = document.getElementById(`guest_${value}_last_name`).value.trim();
        //                                             // Solo letras y espacios, sin números ni caracteres raros
        //                                             let nameRegex = /^[A-Za-zÁÉÍÓÚáéíóúÑñ\s]+$/;
        //
        //                                             if (!firstName.match(nameRegex) || !lastName.match(nameRegex) || firstName === "" || lastName === "") {
        //                                                 validGuests = false;
        //                                                 document.getElementById(`guest_${value}_first_name`).classList.add('is-invalid');
        //                                                 document.getElementById(`guest_${value}_last_name`).classList.add('is-invalid');
        //                                             } else {
        //                                                 document.getElementById(`guest_${value}_first_name`).classList.remove('is-invalid');
        //                                                 document.getElementById(`guest_${value}_last_name`).classList.remove('is-invalid');
        //                                                 guestData.push({
        //                                                     id: value,
        //                                                     firstName: firstName,
        //                                                     lastName: lastName
        //                                                 });
        //                                             }
        //                                         });
        //
        //                                         if (!validGuests) {
        //                                             toastr.error("Por favor, ingrese nombres y apellidos válidos para todos los huéspedes.");
        //                                             return false;
        //                                         }
        //                                         /* Validar los nombres y apellidos de los huéspedes FINN */
        //
        //                                         beforeSend();
        //                                         if (customerFrontendRoom) {
        //                                             url_default = '/complete_booking'
        //                                         }
        //
        //                                         post(`${url_default}`, {
        //                                             query: {
        //                                                 username: document.getElementById('hotel_contact_user_username').value,
        //                                                 lastname: document.getElementById('hotel_contact_user_lastname').value,
        //                                                 email: document.getElementById('hotel_contact_user_email').value,
        //                                                 phone_number: document.getElementById('hotel_contact_user_phone_number').value,
        //                                                 country_code: document.getElementById('hotel_contact_user_country_code').value.toLowerCase(),
        //                                                 postal_code: document.getElementById('hotel_contact_user_postal_code').value,
        //                                                 payment_method: paymentMethod,
        //                                                 currency_cash: currency_cash,
        //                                                 url_go: url_go,
        //                                                 ...(extraInputsFincimex || {}), /* ✅ si es null, inyecta objeto vacío y no rompe */
        //                                                 guests: JSON.stringify(guestData)
        //                                             },
        //                                             responseKind: "json"
        //                                         }).then(async r => {
        //                                             console.log("█ █ █ █ █ █ █ █ █ █ █ █ █ █ █ █ █ █ █ █ █ █ █ █ █ █ █ █ █ ");
        //                                             const body = await r.json;
        //                                             console.log(body);
        //                                             console.log(body.data);
        //                                             console.log("█ █ █ █ █ █ █ █ █ █ █ █ █ █ █ █ █ █ █ █ █ █ █ █ █ █ █ █ █ ");
        //                                             if (r.ok) {
        //                                                 // $('#div_filter_search_hotel').addClass('hide-tooltip');
        //                                             }
        //
        //                                             sessionStorage.setItem('other_param', 'hotel_hotetec');
        //                                             const match = hotel_price.match(/^(\d+(?:\.\d+)?)\s*([A-Z]{3})$/);
        //
        //                                             create_array_for_product('price_hotel', parseFloat(match[1])*100 ); // PRECIO HOTEL EN CARRITO
        //                                             // create_array_for_product('text_price', hotel_price ); // PRECIO HOTEL EN DIV
        //                                             // create_array_for_product('item_id', hotel_code );
        //                                             // create_array_for_product('price_conversion', '1.65');
        //                                             // create_array_for_product('text_price_conversion', hotel_price ); // TEXTO DE DIV DE LOS PRECIOS USD
        //                                             create_array_for_product('amount', hotel_rooms ); //CANTIDAD DE HABITACIONES
        //                                             create_array_for_product('name', hotel_name ); // NOMBRE DE HOTEL EN DIV
        //                                             create_array_for_product('text_category', hotel_name ); // NOMBRE HOTEL EN CARRITO
        //                                             create_array_for_product('dealer', '123');
        //                                             create_array_for_product('dealer_name', 'CUBACAR HOTELES MELIA');
        //                                             create_array_for_product('text_destination', hotel_address );
        //                                             create_array_for_product('date_collect', checkInDate); //FECHA INICIO RESERVA
        //                                             create_array_for_product('date_delivery', checkOutDate);// FECHA FIN RESERVA
        //                                             create_array_for_product('hotel_hotetec', 'hotel_hotetec');
        //                                             create_array_for_product('currency', match[2]);
        //                                             create_array_for_product('hotel_decription', hotel_description);
        //
        //
        //                                             add_direct_product_to_cart(form, block_target, create_array_for_product('dealer', '', 'show'), 'd2922a6fa729ffd9426179ddf74c100291412b57', create_array_for_product('pax', '', 'show'), create_array_for_product('product_type', '', 'show'), create_array_for_product('modality_code', '', 'show')).then(
        //                                                 product_add => {
        //                                                     if (product_add.next) {
        //                                                         unBlockElementById(block_target);
        //
        //                                                         setTimeout(()=>{
        //                                                             location.href = `${location.origin}/${sessionStorage.getItem('locale')}/shopping-cart`
        //                                                         },500)
        //
        //                                                     } else {
        //                                                         unBlockElementById(block_target);
        //                                                         toastr.error('No se pudo añadir el producto', 'Carrito de compra')
        //                                                     }
        //                                                 }
        //                                             )
        //
        //                                         });
        //                                     }
        //                                 } else {
        //                                     let email_user_form = document.getElementById('hotel_contact_user_email');
        //                                     email_user_form.classList.add('is-invalid');
        //                                     email_user_form.classList.remove('is-valid');
        //                                     return false;
        //                                 }
        //                             })
        //
        //                         return false;
        //                     }
        //                 }
        //             },
        //             onShown: function (e) {
        //                 // $(this) referencia al modal generado
        //                 $(this).attr('id', 'dialog_hotel_contact_data');
        //
        //                 // O más específico - el modal principal
        //                 $('.bootbox.modal').last().attr('id', 'dialog_hotel_contact_data');
        //
        //             }
        //         })
        //     }
        // } )

    }

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    complete_booking(e) {
        const paymentMethod = this.selectedRadioPaymentMethod;
        const extraInputsFincimex = this.getExtraInputs();
        let currency_cash = this.currencyCashTarget.value;
        let guestCount = e.target.dataset.guest;
        let url_go = e.target.dataset.urlgo;
        let customerFrontendRoom = document.getElementById("customerFrontendRoom");
        let url_default = '/admin/hotel/complete_booking';
        // const car_count = sessionStorage.getItem('cart_count_product');

        if (paymentMethod === 'fincimex') {
            this.toggleButton();

            if (!extraInputsFincimex) {
                console.warn("No se puede completar la reserva ya que faltan datos del pago mediante FINCIMEX.");
                toastr.error("No se puede completar la reserva ya que faltan datos del pago mediante FINCIMEX.");
                return
            }
        } else if (paymentMethod === 'cash') {
            if (currency_cash === '' || currency_cash === undefined) {
                console.warn("No se puede completar la reserva ya que falta la moneda del pago mediante Efectivo.");
                toastr.error("No se puede completar la reserva ya que falta la moneda del pago mediante Efectivo.");
                return
            }
        }

        // Evita acción si el botón está deshabilitado
        if (this.completeBookingTarget.classList.contains("disabled")) {
            event.preventDefault()
            event.stopPropagation()
            console.warn("No puedes completar la reserva: faltan campos.")
            toastr.error("No puedes completar la reserva: faltan campos.");
            return
        }

        let target = e.target.dataset.target;
        let target_message = e.target.dataset.message;
        let context = this;

        let guestsFields = "";
        // for (let i = 0; i < guestCount.split(',').length; i++) {
        $.each(guestCount.split(','), function (i, value) {
            guestsFields += `
                ${(i === 0) ? '<hr class="mt-3"><h6>Nombre y Apellidos de los Huéspedes</h6>' : ''}
                <div class="row mb-3" style="gap: .5em 0;">
                    <div class="col-md-6">
                        <input type="text" id="guest_${value}_first_name" name="guests[${value}][first_name]" placeholder="Nombre huésped ${i + 1}" class="form-control required">
                    </div>
                    <div class="col-md-6">
                        <input type="text" id="guest_${value}_last_name" name="guests[${value}][last_name]" placeholder="Apellido huésped ${i + 1}" class="form-control required">
                    </div>
                </div>`;
        });

        let dialog_hotel_contact_data = bootbox.dialog({
                title: 'Datos de contacto del cliente',
                message: `<div style="overflow: hidden auto; max-height: 350px; text-align: justify; padding: 5px 10px;"><p class='text-danger small'>(*) Campos obligatorios</p><br>
                    <div id="hotel_contact_user_form" class="row" data-controller="country">
                        <div class="col-12 mb-2">
                         <input id="hotel_contact_user_username" ${(paymentMethod === 'fincimex') ? `value='${extraInputsFincimex['nombre']}'` : ''} type="text" placeholder="* Nombre de cliente" class="form-control required"> 
                        </div>
                        <div class="col-12 mb-2">
                         <input id="hotel_contact_user_lastname" ${(paymentMethod === 'fincimex') ? `value='${extraInputsFincimex['apellidos']}'` : ''} type="text" placeholder="* Apellidos de cliente" class="form-control required"> 
                        </div>
                        <div class="col-12 mb-2">
                         <input id="hotel_contact_user_email" ${(paymentMethod === 'fincimex') ? `value='${extraInputsFincimex['correo_electronico']}'` : ''} type="email" placeholder="* Correo Electrónico" class="form-control required">
<!--                         <small class="text-danger"> Para enviar la notificación y el voucher de la compra.</small> -->
                        </div>
                        <div class="col-12 mb-2">
                         <input id="hotel_contact_user_phone_number" type="text" placeholder="Número de Teléfono" class="form-control"> 
                        </div>
                        <div class="col-12 mb-2">
                         <select id="hotel_contact_user_country_code" class="form-control"> </select>
                         <small class="text-danger"> Norma ISO de dos caracteres.</small>
                        </div>
                        <div class="col-12 mb-2">
                         <input id="hotel_contact_user_postal_code" type="text" placeholder="Código Postal" class="form-control"> 
                        </div>
                    </div>
                    ${guestsFields}
                              </div>`,
                size: 'md',
                buttons: {
                    cancel: {
                        label: "Cancelar",
                        className: 'btn-secondary'
                    },
                    ok: {
                        label: "Confirmar datos",
                        className: 'btn-success',
                        callback: function (e) {
                            let count = 0;
                            let form_required = $('#hotel_contact_user_form').find('.required');
                            form_required.map((index, element) => {
                                if (element.value.isEmpty()) {
                                    count += 1;
                                    $(element)[0].classList.remove('is-valid');
                                    $(element)[0].classList.add('is-invalid');
                                } else {
                                    $(element)[0].classList.add('is-valid');
                                    $(element)[0].classList.remove('is-invalid');
                                }
                            });

                            validate_email(document.getElementById('hotel_contact_user_email').value).then(
                                success => {
                                    if (success) {
                                        if (count > 0) {
                                            return false;
                                        } else {
                                            toastr.info('Validando datos del cliente');
                                            $('button.bootbox-close-button').trigger('click');

                                            $(`#${target}`).html(`<div style="height: 250px"></div>`);

                                            /* El beforeSend se maneja manualmente */
                                            const beforeSend = () => {
                                                console.log('Antes del envío');
                                                // blockElementsById(target, `<div class="d-flex flex-column justify-content-center align-items-center"><span class="fa fa-spinner fa-spin"></span> <span>${I18n.t('global.main.form.message.create_shooping_cart')}</span></div> `, 'rgba(0,0,0,0)', '#ffffff', 'rgba(0,0,0,.6)');
                                                // blockElementsById(target, `<div class="d-flex flex-column justify-content-center align-items-center"><span class="fa fa-spinner fa-spin"></span> <span>Cargandoooooooooo...</span></div> `, 'rgba(0,0,0,0)', '#ffffff', 'rgba(0,0,0,.6)');
                                                blockElementsById(target, `<div class="d-flex flex-column justify-content-center align-items-center"><span class="fa fa-4x fa-spinner fa-spin"></span> <h4 class="w-100 text-center text-info">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" fill="currentColor" class="mr-2" viewBox="0 0 16 16" aria-hidden="true">
                                                            <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm0-1.5A6.5 6.5 0 1 1 8 1.5a6.5 6.5 0 0 1 0 13zm.93-6.588c-.07-.07-.162-.112-.26-.112h-1.34c-.098 0-.19.042-.26.112a.37.37 0 0 0-.11.26c0 .098.042.19.11.26.07.07.162.112.26.112h.47v2.5a.37.37 0 0 0 .37.37h.26a.37.37 0 0 0 .37-.37v-2.5h.47c.098 0 .19-.042.26-.112a.37.37 0 0 0 .11-.26.37.37 0 0 0-.11-.26zm-.93-2.412a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5z"/>
                                                        </svg>
                                                        ${target_message}
                                                        </h4></div> `, 'rgba(0,0,0,0)', '#ffffff', 'rgba(0,0,0,.2)');
                                            };

                                            /* Validar los nombres y apellidos de los huéspedes */
                                            let guestData = [];
                                            let validGuests = true;

                                            // for (let i = 0; i < guestCount; i++) {
                                            $.each(guestCount.split(','), function (i, value) {
                                                let firstName = document.getElementById(`guest_${value}_first_name`).value.trim();
                                                let lastName = document.getElementById(`guest_${value}_last_name`).value.trim();
                                                // Solo letras y espacios, sin números ni caracteres raros
                                                let nameRegex = /^[A-Za-zÁÉÍÓÚáéíóúÑñ\s]+$/;

                                                if (!firstName.match(nameRegex) || !lastName.match(nameRegex) || firstName === "" || lastName === "") {
                                                    validGuests = false;
                                                    document.getElementById(`guest_${value}_first_name`).classList.add('is-invalid');
                                                    document.getElementById(`guest_${value}_last_name`).classList.add('is-invalid');
                                                } else {
                                                    document.getElementById(`guest_${value}_first_name`).classList.remove('is-invalid');
                                                    document.getElementById(`guest_${value}_last_name`).classList.remove('is-invalid');
                                                    guestData.push({
                                                        id: value,
                                                        firstName: firstName,
                                                        lastName: lastName
                                                    });
                                                }
                                            });

                                            if (!validGuests) {
                                                toastr.error("Por favor, ingrese nombres y apellidos válidos para todos los huéspedes.");
                                                return false;
                                            }
                                            /* Validar los nombres y apellidos de los huéspedes FINN */

                                            beforeSend();
                                            if (customerFrontendRoom) {
                                                url_default = '/complete_booking'
                                            }

                                            post(`${url_default}`, {
                                                query: {
                                                    username: document.getElementById('hotel_contact_user_username').value,
                                                    lastname: document.getElementById('hotel_contact_user_lastname').value,
                                                    email: document.getElementById('hotel_contact_user_email').value,
                                                    phone_number: document.getElementById('hotel_contact_user_phone_number').value,
                                                    country_code: document.getElementById('hotel_contact_user_country_code').value.toLowerCase(),
                                                    postal_code: document.getElementById('hotel_contact_user_postal_code').value,
                                                    payment_method: paymentMethod,
                                                    currency_cash: currency_cash,
                                                    url_go: url_go,
                                                    ...(extraInputsFincimex || {}), /* ✅ si es null, inyecta objeto vacío y no rompe */
                                                    guests: JSON.stringify(guestData)
                                                },
                                                responseKind: "turbo-stream"
                                            }).then(r => {
                                                $('#div_filter_search_hotel').addClass('hide-tooltip');
                                                /*this.isLogin(r);
                                                this.setDealerData()*/
                                                console.log("Reserva completada satisfactoriamente.");
                                            });
                                        }
                                    } else {
                                        let email_user_form = document.getElementById('hotel_contact_user_email');
                                        email_user_form.classList.add('is-invalid');
                                        email_user_form.classList.remove('is-valid');
                                        return false;
                                    }
                                })

                            return false;
                        }
                    }
                },
                onShown: function (e) {
                    // $(this) referencia al modal generado
                    $(this).attr('id', 'dialog_hotel_contact_data');

                    // O más específico - el modal principal
                    $('.bootbox.modal').last().attr('id', 'dialog_hotel_contact_data');

                }
            })
        ;
    }

    confirm_booking(e) {
        let target = e.target.dataset.target;
        let payment = e.target.dataset.payment;
        let target_message = e.target.dataset.message;
        let customerFrontendRoom = document.getElementById("customerFrontendRoom");
        let url_default = '/admin/hotel/confirm_booking';

        $(`#${target}`).html(`<div style="height: 250px"></div>`);

        /* El beforeSend se maneja manualmente */
        const beforeSend = () => {
            console.log('Antes del envío');
            // blockElementsById(target, `<div class="d-flex flex-column justify-content-center align-items-center"><span class="fa fa-spinner fa-spin"></span> <span>${I18n.t('global.main.form.message.create_shooping_cart')}</span></div> `, 'rgba(0,0,0,0)', '#ffffff', 'rgba(0,0,0,.6)');
            // blockElementsById(target, `<div class="d-flex flex-column justify-content-center align-items-center"><span class="fa fa-spinner fa-spin"></span> <span>Cargandoooooooooo...</span></div> `, 'rgba(0,0,0,0)', '#ffffff', 'rgba(0,0,0,.6)');
            blockElementsById(target, `<div class="d-flex flex-column justify-content-center align-items-center"><span class="fa fa-4x fa-spinner fa-spin"></span> <h4 class="w-100 text-center text-info">
                    <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" fill="currentColor" class="mr-2" viewBox="0 0 16 16" aria-hidden="true">
                        <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm0-1.5A6.5 6.5 0 1 1 8 1.5a6.5 6.5 0 0 1 0 13zm.93-6.588c-.07-.07-.162-.112-.26-.112h-1.34c-.098 0-.19.042-.26.112a.37.37 0 0 0-.11.26c0 .098.042.19.11.26.07.07.162.112.26.112h.47v2.5a.37.37 0 0 0 .37.37h.26a.37.37 0 0 0 .37-.37v-2.5h.47c.098 0 .19-.042.26-.112a.37.37 0 0 0 .11-.26.37.37 0 0 0-.11-.26zm-.93-2.412a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5z"/>
                    </svg>
                    ${target_message}
                    </h4></div> `, 'rgba(0,0,0,0)', '#ffffff', 'rgba(0,0,0,.2)');
        };

        beforeSend();
        if(customerFrontendRoom){
            url_default = '/confirm_booking'
        }

        console.log("METODO DE CONFIRMAR BOOKING")
        console.log(customerFrontendRoom)
        console.log(url_default)

        post(`${url_default}`, {
            query: {
                target: target,
                payment: payment
            },
            responseKind: "turbo-stream"
        }).then(r => {
            $('#div_filter_search_hotel').addClass('hide-tooltip');
            /*this.isLogin(r);
            this.setDealerData()*/
            console.log("Reserva confirmada satisfactoriamente.");
        });
    }

    cancel_booking(e) {
        let reference = e.target.dataset.reference;
        let target = e.target.dataset.target;
        let target_message = e.target.dataset.message;
        let customerFrontendRoom = document.getElementById("customerFrontendRoom");
        let url_default = '/admin/hotel/cancel_booking';

        bootbox.confirm({
            title: "Cancelar",
            message: "¿Seguro que desea cancelar la reserva?",
            buttons: {
                confirm: {
                    label: '<i class="fa fa-check"></i> Aceptar',
                    className: 'btn-success'
                },
                cancel: {
                    label: '<i class="fa fa-times"></i> Cancelar',
                    className: 'btn-secondary'
                }
            },
            size: 'medium',
            callback: function (result) {
                if (result) {
                    $(`#${target}`).html(`<div style="height: 250px"></div>`);

                    /* El beforeSend se maneja manualmente */
                    const beforeSend = () => {
                        console.log('Antes del envío');
                        // blockElementsById(target, `<div class="d-flex flex-column justify-content-center align-items-center"><span class="fa fa-spinner fa-spin"></span> <span>${I18n.t('global.main.form.message.create_shooping_cart')}</span></div> `, 'rgba(0,0,0,0)', '#ffffff', 'rgba(0,0,0,.6)');
                        // blockElementsById(target, `<div class="d-flex flex-column justify-content-center align-items-center"><span class="fa fa-spinner fa-spin"></span> <span>Cargandoooooooooo...</span></div> `, 'rgba(0,0,0,0)', '#ffffff', 'rgba(0,0,0,.6)');
                        blockElementsById(target, `<div class="d-flex flex-column justify-content-center align-items-center"><span class="fa fa-4x fa-spinner fa-spin"></span> <h4 class="w-100 text-center text-info">
                                <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" fill="currentColor" class="mr-2" viewBox="0 0 16 16" aria-hidden="true">
                                    <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm0-1.5A6.5 6.5 0 1 1 8 1.5a6.5 6.5 0 0 1 0 13zm.93-6.588c-.07-.07-.162-.112-.26-.112h-1.34c-.098 0-.19.042-.26.112a.37.37 0 0 0-.11.26c0 .098.042.19.11.26.07.07.162.112.26.112h.47v2.5a.37.37 0 0 0 .37.37h.26a.37.37 0 0 0 .37-.37v-2.5h.47c.098 0 .19-.042.26-.112a.37.37 0 0 0 .11-.26.37.37 0 0 0-.11-.26zm-.93-2.412a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5z"/>
                                </svg>
                                ${target_message}
                                </h4></div> `, 'rgba(0,0,0,0)', '#ffffff', 'rgba(0,0,0,.2)');
                    };

                    beforeSend();
                    if(customerFrontendRoom){
                        url_default = '/cancel_booking'
                    }

                    console.log("METODO DE Cancel BOOKING")
                    console.log(customerFrontendRoom)
                    console.log(url_default)

                    post(`${url_default}`, {
                        query: {
                            booking_reference: reference,
                            target: target
                        },
                        responseKind: "turbo-stream"
                    }).then(r => {
                        /*this.isLogin(r);
                        this.setDealerData()*/
                        console.log("Reserva Cancelada");
                    });
                }
            }
        })
    }

    other_booking() {
        let customerFrontendRoom = document.getElementById("customerFrontendRoom");
        let url_default = '/admin/hotel/other_booking';

        if(customerFrontendRoom){
            url_default = '/other_booking'
        }

        console.log("METODO DE OTHER")
        console.log(customerFrontendRoom)
        console.log(url_default)

        post(`${url_default}`, {
            query: {}
        }).then(r => {
            /*this.isLogin(r);
            this.setDealerData()*/
            console.log("Puede realizar otra Reserva.");
        });
    }

    before_send(e) {
        let target = e.target.dataset.target;
        let result = e.target.dataset.result;
        let target_message = e.target.dataset.message;

        $(`#${result}`).addClass(`show`);

        const beforeSend = () => {
            $(`#${target}`).html(`<div style="height: 250px"></div>`);

            // blockElementsById(target, `<div class="d-flex flex-column justify-content-center align-items-center"><span class="fa fa-spinner fa-spin"></span> <span>${I18n.t('global.main.form.message.create_shooping_cart')}</span></div> `, 'rgba(0,0,0,0)', '#ffffff', 'rgba(0,0,0,.6)');
            blockElementsById(target, `<div class="d-flex flex-column justify-content-center align-items-center"><span class="fa fa-4x fa-spinner fa-spin"></span> <h4 class="w-100 text-center text-info">
              <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" fill="currentColor" class="mr-2" viewBox="0 0 16 16" aria-hidden="true">
                <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm0-1.5A6.5 6.5 0 1 1 8 1.5a6.5 6.5 0 0 1 0 13zm.93-6.588c-.07-.07-.162-.112-.26-.112h-1.34c-.098 0-.19.042-.26.112a.37.37 0 0 0-.11.26c0 .098.042.19.11.26.07.07.162.112.26.112h.47v2.5a.37.37 0 0 0 .37.37h.26a.37.37 0 0 0 .37-.37v-2.5h.47c.098 0 .19-.042.26-.112a.37.37 0 0 0 .11-.26.37.37 0 0 0-.11-.26zm-.93-2.412a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5z"/>
              </svg>
              ${target_message}
            </h4></div> `, 'rgba(0,0,0,0)', '#ffffff', 'rgba(0,0,0,.2)');
        };

        beforeSend();
    }

    show_text_rate(e) {
        let name = e.target.dataset.name;
        let description = e.target.dataset.description;
        let conditions = e.target.dataset.conditions;

        bootbox.alert({
            title: name,
            message: `<div id="" class="row" style="overflow: hidden auto; max-height: 350px; text-align: justify; padding: 5px 10px;">
                        <div class="col-12 mb-2">
                            <h4>Descripción</h4>
                            <p>${description}</p>
                        </div>
                        <hr>
                        <div class="col-12 mb-2">
                            <h4>Condiciones</h4>
                            <p>${conditions}</p>
                        </div>
                    </div>`,
            size: 'lg',
            buttons:{
                ok: {
                    label: "Cerrar",
                    className: 'btn btn-info',
                    callback: function (e) {
                        return false;
                    }
                }
            }
        });
    }
}
